document.addEventListener("DOMContentLoaded", () => {
  if (!Splide) {
    return;
  }

  const splide = new Splide('.splide', {
    arrows: false,
    autoplay: false,
    gap: '40px',
    lazyLoad: true,
    padding: { left: '5%', right: '10%' },
    pagination: true,
    perPage: 5,
    rewind : false,
    type: 'loop',

    breakpoints: {
      480: {
        perPage: 2, gap: 0, padding: { left: '0%', right: '15%' },
      },
      640: {
        perPage: 3, gap: 0, padding: { left: '0%', right: '20%' },
      },
    },
  });
  splide.mount();
});
